import { useEffect, useRef, useState, useContext } from "react";
import { Loading } from "../polaris";
import { callGPT } from "../http/callGPT.jsx";
import { UserContext } from '../providers/UserContext';


export function Chat() {

  function ToggleableText({ label, content, theme }) {
  const [open, setOpen] = useState(false);
  return (
    <p
      className="mt-3 cursor-pointer select-none"
      style={{ color: theme.textColor }}
      onClick={() => setOpen(!open)}
    >
      {label}
      {open && (
        <div className="mt-1">
          <i>{content}</i>
        </div>
      )}
    </p>
  );
}


  let token = "";
  const { darkMode, theme } = useContext(UserContext);
  const [chatboxh, setChatboxh] = useState("400px");
  const [openedTime, setOpenedTime] = useState("");
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const suffix = hours >= 12 ? "CH" : "SA";
    const formattedHour = (hours % 12) || 12;
    setOpenedTime(`${formattedHour}:${minutes} ${suffix}`);
  }, []);

  const [messages, setMessages] = useState([
    { role: "assistant", content: "Hi there! Lisa's here from Norway. Ready for some fun English practice? Type away!" }
  ]);

  

  const [loading, setLoading] = useState(false);

  const bottomRef = useRef(null); // 📍

  // Auto-scroll xuống cuối khi messages thay đổi
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const changeContent = (event) => {
    setInputValue(event.target.value);
  };

const AskGPT = async () => {
  if (!inputValue.trim()) {
    alert("Vui lòng nhập câu hỏi!");
    return;
  }

  setLoading(true);
  const userMessage = { role: "user", content: inputValue };
  setMessages((prev) => [...prev, userMessage]);
  setInputValue(""); // reset input sau khi gửi
  try {
    const res = await callGPT(token, inputValue);
    console.warn(res)
    const aiMessage = {
      role: "assistant",
      content: res?.answer || "Something went wrong ... ",
    };
    setMessages((prev) => [...prev, aiMessage]);
  } catch (error) {
    setMessages((prev) => [
      ...prev,
      { role: "assistant", content: "Có lỗi khi gọi API." },
    ]);
  }

  setLoading(false);
  
};
const handleKeyDown = (e) => {
  if (e.key === "Enter" && !e.shiftKey) {
    e.preventDefault();
    AskGPT();
  }
};

  return (
    <>
    <div
        className="text-base md:text-sm fixed bottom-2 right-2 flex flex-col w-[90vw] md:w-[350px] rounded-xl shadow-xl overflow-hidden"
        style={{ height: chatboxh,border: "solid 1px " + theme.textColor, zIndex: 9999999999, background: theme.backgroundLight, color: theme.textColor }} // đảm bảo không bị che
      >
        {/* Header */}
        <div onClick={() => {
          if(chatboxh === "400px"){ setChatboxh("45px"); } else{setChatboxh("400px");}
        }} 
        className="p-2 flex items-center justify-between" 
        style={{
          borderBottom: "solid 1px " + theme.textColor, transition: "all 1s"
        }}>
          <div className="font-semibold flex items-center gap-2">
            <div className="relative">
              <img
                src="https://cdn-images.dzcdn.net/images/artist/577669c2e889007f0ffe528caad0f1e4/1900x1900-000000-80-0-0.jpg"
                className="rounded-full w-[25px] h-[25px]"
              />
              <span className="absolute bottom-0 right-0 w-[8px] h-[8px] bg-green-500 rounded-full border border-white"></span>
            </div>
            <span className="self-center">Lisa</span>
          </div>

          <div className="flex gap-2">
            <button>─</button>
            <button>✖</button>
          </div>
        </div>

        {/* Chat area */}
        <div className="flex-1 overflow-y-auto p-3 space-y-2" style={{ overscrollBehavior: "contain" }}>
          {/* Messages */}
            {messages.map((msg, idx) => {
            const isUser = msg.role === "user";
            let english = msg.content;
            let vietnamese = "";
            let correction = "";
            let isTranslated = false;

            try {
              const parsed = JSON.parse(msg.content);
              console.log(parsed.correction)
              if (parsed.english && parsed.vietnamese) {
                english = parsed.english;
                vietnamese = parsed.vietnamese;
                isTranslated = true;
              }
              if ("correction" in parsed) {
                correction = parsed.correction || ""; // fallback nếu null
              }

            } catch (err) {
              // plain text
            }

            return (
              <div
                key={idx}
                className={`flex ${isUser ? "justify-end" : "justify-start"}`}
              >
                <div
                  className={`px-3 py-2 rounded-2xl max-w-[80%] break-words ${
                    isUser ? "rounded-br-sm" : "rounded-bl-sm"
                  }`}
                  style={{
                    backgroundColor: !isUser ? theme.backgroundHeavy : "",
                    border: !isUser ? "" : "solid 1px " + theme.textColor,
                  }}
                >
                  <div>{english}</div>

                  {!isUser && isTranslated && (
                    <ToggleableText label="Dịch" content={vietnamese} theme={theme} />
                  )}

                  {!isUser && correction && (
                    <ToggleableText label="Sửa ngữ pháp" content={correction} theme={theme} />
                  )}


                </div>
              </div>
            );
          })}

          {/* Scroll target, should be after all messages */}
          <div ref={bottomRef} />
            {loading && (
              <div className="flex justify-center">
                <Loading color={theme.backgroundHeavy}/>
              </div>
            )}


          {/* Thời gian giả lập */}
          {openedTime && (
              <div className="text-center text-[11px] text-gray-400 pt-2">
                {openedTime}
              </div>
            )}
        </div>

        {/* Input bar */}
        <div className="flex items-center px-1 py-2 gap-2" style={{borderTop:"solid 1px " + theme.textColor}}>
          <button className="text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="m5.008 9.61-2.01-4.75c-.354-.838.506-1.676 1.336-1.3l12.163 5.53a1 1 0 0 1 0 1.82l-12.163 5.53c-.83.376-1.69-.462-1.335-1.3l2.01-4.75a1 1 0 0 0 0-.78Zm1.382-.584-1.51-3.57 9.995 4.544-9.995 4.543 1.51-3.569c.03-.074.058-.148.082-.224h3.778a.75.75 0 0 0 0-1.5h-3.778a2.5 2.5 0 0 0-.082-.224Z"/></svg>
          </button>
          <input
            type="text"
            placeholder="Aa"
            value={inputValue}
            onChange={changeContent}
            onKeyDown={handleKeyDown}
            className="flex-1 px-3 py-1.5 rounded-full outline-none"
            style={{backgroundColor: theme.backgroundHeavy, border: "solid 1px " + theme.textColor}}
          />
          <button
            onClick={AskGPT}
            className="w-8 h-8 rounded-full flex items-center justify-center"
            style={{backgroundColor: theme.backgroundHeavy, color: theme.textColor}}
          >
            ➤
          </button>
        </div>
      </div>
    </>
  );
}
